import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, CalendarDays, Clock, MapPin, ArrowRight } from "lucide-react";
import { publicApi } from "@/lib/api";
import { Loader, fmtEventDate } from "@/components/public/ui";

export default function EventDetail() {
  const { slug } = useParams();
  const [e, setE] = useState(undefined);

  useEffect(() => {
    setE(undefined);
    publicApi.get(`/events/${slug}`).then((r) => setE(r.data)).catch(() => setE(null));
  }, [slug]);

  if (e === undefined) return <div className="pt-20"><Loader /></div>;
  if (e === null)
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 pt-20">
        <p className="font-serif text-3xl text-[#18344A]">Event not found</p>
        <Link to="/happenings" className="text-sm font-semibold uppercase tracking-wide text-[#526E7E]">All Happenings</Link>
      </div>
    );

  return (
    <div className="pt-20">
      <section className="bg-[#18344A] py-16 text-white">
        <div className="mx-auto w-full max-w-[900px] px-5 lg:px-8">
          <Link to="/happenings" className="mb-5 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-white/70 hover:text-white">
            <ArrowLeft className="h-4 w-4" /> All Happenings
          </Link>
          <p className="text-xs font-semibold uppercase tracking-[0.14em] text-[#B7A58E]">{e.property_name}</p>
          <h1 className="mt-2 font-serif text-[40px] leading-tight text-white sm:text-[56px]">{e.title}</h1>
        </div>
      </section>

      {e.image && (
        <section className="mx-auto max-w-[900px] px-5 pt-16 lg:px-8">
          <div className="overflow-hidden rounded-2xl">
            <img src={e.image} alt={e.title} className="aspect-[21/9] w-full object-cover" />
          </div>
        </section>
      )}

      <section className="mx-auto max-w-[900px] px-5 py-16 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <p className="text-[16px] leading-relaxed text-[rgba(48,56,60,0.8)]">{e.description}</p>
          </div>
          <aside className="h-fit rounded-2xl border border-[var(--pb-border)] bg-[#F5F3EF] p-6">
            <div className="space-y-3 text-sm text-[rgba(48,56,60,0.82)]">
              <p className="flex items-center gap-2"><CalendarDays className="h-4 w-4 text-[#526E7E]" /> {fmtEventDate(e.date)}</p>
              {e.time && <p className="flex items-center gap-2"><Clock className="h-4 w-4 text-[#526E7E]" /> {e.time}</p>}
              <p className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#526E7E]" /> {e.location}</p>
            </div>
            {e.reservation_link ? (
              <a href={e.reservation_link} target="_blank" rel="noreferrer" className="mt-6 flex items-center justify-center gap-2 rounded-full bg-[#18344A] px-6 py-3 text-sm font-semibold uppercase tracking-[0.06em] text-white hover:bg-[#18344A]/90">
                Reserve <ArrowRight className="h-4 w-4" />
              </a>
            ) : (
              <Link to="/contact" className="mt-6 flex items-center justify-center gap-2 rounded-full bg-[#18344A] px-6 py-3 text-sm font-semibold uppercase tracking-[0.06em] text-white hover:bg-[#18344A]/90">
                Inquire <ArrowRight className="h-4 w-4" />
              </Link>
            )}
          </aside>
        </div>
      </section>
    </div>
  );
}
